
<div class="rfp-rr-ratings-helpful-018-or rr-like-review clear float-left">
  <p class="rfp-rr-ratings-helpful-019-or">
    <span class="rfp-rr-ratings-helpful-020-or">{{ helpfulLabel }}</span>
  </p>
  <div class="rfp-rr-ratings-helpful-021-or rr-like-section float-left">
    <p
      v-if="helpfulCountCookieLocal != rrid && IsHelpfulCookie == 'no'"
      class="rfp-rr-ratings-helpful-022-or"
      @click="UpdateHelpfulReview"
    >
      <img
        :src="helpfulIconss"
        class="rfp-rr-ratings-helpful-023-or image-setup-for-list"
        :alt="helpfulIconAltss"
      />
    </p>
    <p v-else>
      <img
        :src="helpfulIconss"
        class="rfp-rr-ratings-helpful-024-or image-setup-for-list"
        :alt="helpfulIconAltss"
      />
    </p>
    <p>
      <span class="rfp-rr-ratings-helpful-025-or bold">{{ HelpfulCountsCount }}</span>
    </p>
    <p
      v-if="helpfulCountCookieLocal != rrid && IsHelpfulCookie == 'no'"
      class="rfp-rr-ratings-helpful-026-or"
      @click="UpdateNotHelpfulReview"
    >
      <img
        :src="nonHelpfulIconss"
        class="rfp-rr-ratings-helpful-027-or image-setup-for-list"
        :alt="nonHelpfulIconAltss"
      />
    </p>
    <p v-else>
      <img
        :src="nonHelpfulIconss"
        class="rfp-rr-ratings-helpful-028-or image-setup-for-list"
        :alt="nonHelpfulIconAltss"
      />
    </p>
    <p>
      <span class="rfp-rr-ratings-helpful-029-or bold">{{ NotHelpfulCountsCount }}</span>
    </p>
    <p>
      <a
        v-if="reportDisplayed != rrid && report == reportText"
        class="rfp-rr-ratings-helpful-030-or aReported"
        @click="ratingSummary"
        >{{ reportText }}</a
      >
      <a v-else class="rfp-rr-ratings-helpful-031-or aReported">{{ reportedText }}</a>
    </p>
    <p v-if="facebookShareEnabledss" class="rfp-ratings-social-share">
      <rfp-ratings-social-share
        :url="currentPageUrl"
        :title="productNamess"
        :description="reviewContentss"
        :quote="reviewTitless"
        :facebooks="facebookCaptionss"
        :show-fb-media-texts="shareDisplayConfigss"
        :facebook-icons="facebookIconss"
        :facebook-icon-alt="facebookIconAltss"
      >
        <social-sharing-network network="facebook">
          <p v-if="facebookIcons == ''">
            <span
              v-if="showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Icon'"
              class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
            ></span>
          </p>
          <p v-else>
            <img
              v-if="
                (facebookIcons != '' && showFbMediaTexts == 'Icon and Text') ||
                showFbMediaTexts == 'Icon'
              "
              :src="facebookIcons"
              :title="facebookIconAlt"
              class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
              :alt="facebookIconAlt"
            />
          </p>
          <span v-if="showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Text'">{{
            facebooks
          }}</span>
        </social-sharing-network>
      </rfp-ratings-social-share>
    </p>
  </div>
</div>
